import { useEffect, useRef, useState } from 'react';

/**
 * Intersection Observerを使用して要素の遅延読み込みを行うカスタムフック
 * @param options Intersection Observerのオプション
 * @returns [ref, isIntersecting] - ref: 監視対象の要素に設定するref, isIntersecting: 要素がビューポート内に入ったかどうか
 */
export const useLazyLoad = <T extends HTMLElement>(options?: IntersectionObserverInit) => {
    const [isIntersecting, setIntersecting] = useState(false);
    const ref = useRef<T | null>(null);

    useEffect(() => {
        // isIntersectingがtrueになったら何もしない
        if (isIntersecting) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setIntersecting(true);
                if (ref.current) {
                    observer.unobserve(ref.current);
                }
            }
        }, options);

        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [isIntersecting, options]);

    return [ref, isIntersecting] as const;
};
